import classNames from 'classnames';
import { DataContext } from 'hooks/HeaderContext';
import React, { FC, useContext } from 'react';
import { Label } from 'reactstrap';
interface DogListSortSelectProps {
    isMobile: boolean
}

const DogListSortSelect: FC<DogListSortSelectProps> = ({ isMobile }) => {
    const { sortType, setSortType } = useContext(DataContext)
    return (
        <div className="row align-items-center mb-1" >
            <div className={classNames(isMobile ? 'd-none' : 'col-auto')}>
                <label className='col-form-label' htmlFor={`floatingSelect${isMobile ? 'mobile' : ''}`}>Sort By:</label>
            </div>
            <div className='col-lg-auto d-flex'>
                <select
                    aria-label='Sort Available Dogs'
                    className="form-select "
                    style={{ width: '100%' }}
                    id={`floatingSelect${isMobile ? 'mobile' : ''}`}
                    // aria-labelledby='floatingSelectLabel'
                    // aria-label="Floating label select example"
                    onChange={(e) => setSortType(e.currentTarget.value)}
                    onInput={(e) => setSortType(e.currentTarget.value)}
                    value={sortType}
                >
                    <option value="name">Name</option>
                    <option value="newest">Newest Addition</option>
                    <option value="oldest">Oldest Addition</option>
                    <option value="breed">Breed</option>
                </select>
            </div>
        </div>
    )
}

export default DogListSortSelect;




















